import * as React from 'react';

import './HeaderToolbar.scss';

type Props = {
	children: React.ReactNode;
};

const HeaderToolbar = ({children}: Props) => <div className="di header-toolbar">{children}</div>;

export default HeaderToolbar;
